import React from 'react'
import '../../pages/Portfolio/Portfolio.scss'

import {Fade} from "react-reveal";
import {toTitle} from "../../util";
import {Link} from "react-router-dom";
import {assetUrl} from "../../serviceApi";
import Skeleton from "react-loading-skeleton";

const SearchIcon = assetUrl + "images/search-icon-white.svg";
const arrowUp = assetUrl + 'images/green-up-arrow.svg'
const tag = assetUrl + 'images/Price.svg'
const trend = assetUrl + 'images/trending-up.svg'
const arrowdown = assetUrl + 'images/arrowdown.svg'

const PastTransaction = (props) => {
	const stylePastTransaction = "past-transaction-"
	const {pastTransactionData, componentLoading} = props;

	const getFormattedDate = (date) => {
		let today = new Date(date);
		return today.getDate() + "/" + parseInt(today.getMonth() + 1) + "/" + today.getFullYear();
	}
	let pastTransactionListing = pastTransactionData.map(item => {
		let pastTransactinOrderMode = ((item.node.orderMode).replace("_", " ").toLowerCase()).split(" ")
		return <div key={item.node.id}>
			{/*<Fade bottom>*/}
			<>
				<div className={stylePastTransaction + "card"}>
					<div
						className={stylePastTransaction + "card-top d-flex justify-content-between align-items-center"}>
						<Link className={'d-flex align-items-center'}
						      to={"/stock-detail/" + item.node.stock.id}>
							<img src={item.node.orderType === "SELL" ? arrowdown : arrowUp}
							     alt={"alt"} className={""}/>
							<div style={{marginLeft: "8px"}}>
								<p className={stylePastTransaction + "card-name"}>{item.node.stock.name}</p>
								<p className={stylePastTransaction + "card-date"}>
									{item.node.orderType.toLowerCase() === "buy" ? "Bought on " : "Sold on "}
									{getFormattedDate(item.node.created)}</p>
							</div>
						</Link>
						<p className={stylePastTransaction + "card-price"}>₹ {item.node.pastTransactionOrderWiseAvgPrice}</p>
					</div>
					<div className={"transaction-divider"}/>
					<div className={stylePastTransaction + "card-bottom d-flex"}>
						<div className={'d-flex'} style={{marginRight: "16px"}}>
							<img src={tag} alt={'alt'} className={''}/>
							<p className={stylePastTransaction + "card-bottom-text"}>{toTitle(pastTransactinOrderMode[0]) + " " + toTitle(pastTransactinOrderMode[1])}</p>
						</div>
						<div className={'d-flex'}>
							<img src={trend} alt={'alt'} className={''}/>
							<p className={stylePastTransaction + "card-bottom-text"}>{item.node.quantity} {item.node.quantity > 1 ? " Shares" : " Share"}</p>
						</div>
					</div>
				</div>
			</>
		</div>

	})

	return (
		<div className={stylePastTransaction + " main"}>
			<div>
				{
					 pastTransactionData < 1?
						<Skeleton width={"100%"} style={{marginBottom:"12px"}} height={"130px"} count={4}/> :
						<>
							{
								pastTransactionData.length > 1 ?
									<Fade left cascade delay={1500}>
										{
											pastTransactionListing
										}
									</Fade>
									: pastTransactionData.length === 1 ? <div>
										{
											pastTransactionListing
										}
									</div> : <div className={"error-section"}>No Datas Found</div>
							}
						</>

				}
			</div>

		</div>
	)
}

export default PastTransaction;
